module.exports = "<app-marketer-list></app-marketer-list>\r\n"